<template>
    <div class="container ">
        <div class="row mt-5 pt-4">
            <div class="col-12 col-lg-6   pt-0 pb-5 pr-sm-4">
                <div class="title">
                    <div class="cartSummary text-justify" style="font-size:16px !important;">Vous avez une carte cadeaux ou un code promotion ?</div>
                    <div class="addYourCode1 d-none d-lg-block pb-2">Ajoutez votre code pour une remise immédiate</div>
                </div>
                <div class="form w-100">
                    <div class="formInput">
                        <div class="input">
                            <div class="iconinput">
                                <input type="text" id="codeInput" class="codeInput" placeholder="Votre code" v-model="cart.giftCardCode" />

                            </div>
                            <div class="button">
                                <div class="content1">
                                    <div class="getStarted" @click="!cart.lines.giftCardAmount || !cart.lines.finalAmountToPay ? validationGiftCardCode(1) : validationGiftCardCode()">{{ !cart.lines.giftCardAmount || !cart.lines.finalAmountToPay  ? 'Valider':'Retirer'}} </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-6 elementscartcouponForm p-4">
                <div class="cartSummary mb-3">Panier</div>
                <div class="content2">
                    <div class="fields">
                        <div class="shippingOptions">



                            <div v-for="(deliveryMode, index) in deliveryModes" :key="index"  
                                @click="selectDeliveryMode(deliveryMode)"
                                :class=" isDeliverySelected(deliveryMode) ? 'elementsradioButtonFieldSelected' : 'elementsradioButtonField'">
                            
                                <div class="titleamount">
                                    <div class="radioButton1">
                                        <img v-if="isDeliverySelected(deliveryMode)" class="radioButtonIcon1" alt=""
                                            src="../assets/icons/radio-selected.svg" />
                                        <div v-else class="radioButton3" />

                                        <div class="freeShipping text-dark">{{ deliveryMode.name }}</div>


                                        <b-spinner v-if="isCartLoading && selectedDeliveryMode && selectedDeliveryMode.id == deliveryMode.id" 
                                            variant="dark"
                                                small class="mr-2" ></b-spinner>

                                    </div>
                                    <div class="div">{{ isDeliveryFree(deliveryMode)  ? 'Gratuit' : ('+ ' + deliveryMode.cost) }}</div>
                                </div>

                            </div>
                        </div>
                        
                        <div class="elementsorderSummaryinfoFi mt-3">
                            <div class="content5">
                                <div class="titleamount">
                                    <div class="title1">
                                        <div class="freeShipping text-dark">Sous Total</div>
                                    </div>
                                    <div class="value font-weight-normal text-dark">{{ cart.lines.cartSubTotal }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="cart.lines.cartDiscountAsFloat" class="elementsorderSummaryinfoFi mt-1 mb-1">
                            <div class="content5">
                                <div class="titleamount">
                                    <div class="title1">
                                        <div class="text-warning">
                                            Remise sur Panier 
                                            <div class="tooltip-container">
                                                <img  alt="" width="15px" class="" src="../assets/icons/info.svg"   @mouseover="showDiscountTootltip=true" @mouseleave="showDiscountTootltip=false" />  

                                            <div v-if="showDiscountTootltip && cart.lines.cartDiscountRule"  v-html="cart.lines.cartDiscountRule.replace(/;/g, '<br>')"  class="tooltip"></div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="value text-warning">{{ cart.lines.cartDiscount }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="elementsorderSummaryinfoFi mt-1 mb-1">
                            <div class="content5">
                                <div class="titleamount">
                                    <div class="title1">
                                        <div class="freeShipping text-dark">Frais de port</div>
                                    </div>
                                    <div class="value font-weight-normal text-dark">{{ cart.lines.cartDelievryCost }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="elementsorderSummaryinfoFi1  mt-1 mb-1">
                            <div class="content5">
                                <div class="titleamount ">
                                    <div class="label1 text-dark">Total</div>
                                    <div class="value1 text-dark">{{ cart.lines.cartTotal }}</div>
                                </div>
                            </div>
                        </div>

                        <div v-if="cart.lines.giftCardAmount" class="elementsorderSummaryinfoFi mt-1 mb-1">
                            <div class="content5">
                                <div class="titleamount">
                                    <div class="title1">
                                        <div class="freeShipping text-dark">{{ $t('giftCard.payment') }}


                                            <div v-if="cart.lines.giftCardDiscountedItemsWarning" class="tooltip-container">
                                                <img  alt="" width="15px" class="" src="../assets/icons/info.svg"   @mouseover="showGiftCardWarningTootltip=true" @mouseleave="showGiftCardWarningTootltip=false" />  

                                                <div v-if="showGiftCardWarningTootltip && cart.lines.giftCardDiscountedItemsWarning"  class="tooltip">Le code promo ne s'applique pas sur les articles soldés</div>
                                            </div>
                                        



                                        </div>
                                    </div>
                                    <div class="value font-weight-normal text-dark">{{ cart.lines.giftCardAmount }}</div>
                                </div>
                            </div>
                        </div>

                        <div v-if="cart.lines.finalAmountToPay" class="elementsorderSummaryinfoFi1 mt-1 mb-1">
                            <div class="content5">
                                <div class="titleamount">
                                    <div class="title1">
                                        <div class="freeShipping text-dark font-weight-bold">Net à payer </div>
                                    </div>
                                    <div class="value font-weight-normal text-dark font-weight-bold">{{ cart.lines.finalAmountToPay }}</div>
                                </div>
                            </div>
                        </div>



                    </div>
                    <router-link to="/paiement" class="button1" :disabled="!selectedDeliveryMode" >
                        <div class="getStarted1">Payer</div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script >
import CartApi from "@/services/cart-api";


export default ({
    name: "ElementsCartCartSummary",

    props: {
        deliveryModes:{
            type: Array
        },

        cart:{
            type: Object
        },
    },

    mounted() {
        this.selectedDeliveryMode = this.cart ? this.cart.deliveryMode : null; 
    },

    data() {
        return {
            selectedDeliveryMode: null,
            isCartLoading: false,

            showDiscountTootltip: false,
            showGiftCardWarningTootltip: false,

            giftCard:{code:null},
        };
    },

    watch: {
        deliveryModes: function() {
            this.selectedDeliveryMode = this.deliveryModes[0];
        },
    },

    methods: {
    
        validationGiftCardCode(action){
            const setGiftCardToCartRequest ={
                giftCardCode: this.cart.giftCardCode,
                cartId: this.cart.cartId,
                action: action
            }
            CartApi.validationGiftCardCode(setGiftCardToCartRequest).then((result)=>{
                if(result){
                    this.cart = result
                }
            })
        },

        selectDeliveryMode(deliveryMode) {

            if (!deliveryMode) {
                return;
            }

            this.selectedDeliveryMode = deliveryMode;

            this.isCartLoading = true;
            this.$store.dispatch('setDeliveryModeToCart', this.selectedDeliveryMode ? this.selectedDeliveryMode.id : null )
            .finally(() => {
                this.isCartLoading = false;
            });
        },

        isDeliverySelected(deliveryMode) {
            return this.cart && this.cart.deliveryMode && this.cart.deliveryMode.id == deliveryMode.id;
        },

        isDeliveryFree(deliveryMode) {
            return this.cart && this.cart.lines && this.cart.lines.cartSubTotalAsFloat && deliveryMode.deliveryFreeThreshold 
                ? this.cart.lines.cartSubTotalAsFloat >= deliveryMode.deliveryFreeThreshold 
                : false;
        },
    },

    computed: {

        
    }
})
</script>
<style scoped>

.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  white-space: nowrap;
  z-index: 9999;
  opacity: 0.9;
  font-size:14px;
  display: inline-block;
}

.addYourCode1 {
    align-self: stretch;
    position: relative;
    font-size: 16px;
    line-height: 26px;
    font-family: Inter;
    color: #605f5f;
}

.title {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 7px;
}

.codeInput {
    flex: 1;
    height: 100%;
    /* Take up the full height of the parent container */
    border: none;
    outline: none;
    font-size: 16px;
}

.iconinput {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}

.getStarted {
    position: relative;
    line-height: 24px;
    font-weight: 500;
    cursor: pointer;
}

.content1 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}

.button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    font-size: 14px;
    color: #121212;
    font-family: 'Space Grotesk';
}

.input {
    align-self: stretch;
    border-radius: 6px;
    background-color: #fff;
    border: 1px solid #cbcbcb;
    box-sizing: border-box;
    height: 52px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 0px 16px;
    gap: 8px;

    max-width:400px;
}

.formInput {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
}

.form {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    font-size: 16px;
    color: #605f5f;
    font-family: Inter;
}

.elementscartcouponForm {
    width: 100%;
    border: 1px solid #ddd;
    border-radius:8px;
}

.cartSummary {
    align-self: stretch;
    position: relative;
    line-height: 34px;
    font-weight: 500;
    font-size: 22px;
    color: #121212;
}

.radioButtonIcon1 {
    position: relative;
    border-radius: 100px;
    width: 19px;
    height: 19px;
}

.freeShipping {
    position: relative;
    line-height: 26px;
}

.radioButton1 {
    position: absolute;
    top: calc(50% - 13px);
    left: 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
}

.div {
    position: absolute;
    top: calc(50% - 13px);
    right: 0px;
    line-height: 26px;
    text-align: right;
}

.elementsradioButtonFieldSelected {
    align-self: stretch;
    border-radius: 4px;
    background-color: #fafafb;
    border: 1px solid #121212;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 13px 16px;
    cursor: pointer;
}

.radioButton3 {
    position: relative;
    border-radius: 100px;
    border: 1px solid #121212;
    box-sizing: border-box;
    width: 19px;
    height: 19px;
}

.elementsradioButtonField {
    align-self: stretch;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid #cbcbcb;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 13px 16px;
    cursor: pointer;
}

.shippingOptions {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0px 0px 16px;
    gap: 12px;
}

.title1 {
    position: absolute;
    top: calc(50% - 13px);
    left: 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}

.value {
    position: absolute;
    top: calc(50% - 13px);
    right: 0px;
    line-height: 26px;
    font-weight: 600;
    text-align: right;
}

.titleamount {
    flex: 1;
    position: relative;
    height: 26px;
}

.content5 {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}

.elementsorderSummaryinfoFi {
    align-self: stretch;
    border-bottom: 1px solid #eaeaea;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 13px 0px;
}

.label1 {
    position: absolute;
    top: 0px;
    left: 0px;
    line-height: 30px;
    font-weight: 600;
}

.value1 {
    position: absolute;
    top: calc(50% - 13px);
    right: 0px;
    font-size: 16px;
    line-height: 26px;
    font-weight: 600;
    text-align: right;
}

.elementsorderSummaryinfoFi1 {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 13px 0px;
    font-size: 18px;
    border-bottom: 1px solid #eaeaea;
}

.fields {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0px 0px 32px;
}

.getStarted1 {
    position: relative;
    letter-spacing: -0.4px;
    line-height: 32px;
    font-weight: 500;
}

.button1 {
    align-self: stretch;
    border-radius: 6px;
    background-color: #121212;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 10px 26px;
    cursor: pointer;
    text-align: center;
    font-size: 18px;
    color: #fff;
    font-family: 'Space Grotesk';
}

.content2 {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    font-size: 16px;
    font-family: Inter;
}

.elementscartsummary {
    position: absolute;
    top: 0px;
    left: 569px;
    border-radius: 6px;
    background-color: #fff;
    border: 1px solid #cbcbcb;
    box-sizing: border-box;
    width: 538px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 24px;
    gap: 16px;
}

.content {
    position: relative;
    width: 1107px;
    height: 418px;
}

@media (max-width: 768px) {
    .content {
        width: 150%;
        height: auto;
    }
}
</style>